import cms_current_en from "../../json/cms_current_en.json";
import cms_current_ko from "../../json/cms_current_ko.json";

const AllDataClass: any = () => {};
export default AllDataClass;

AllDataClass.current_json;
AllDataClass.Language;
AllDataClass.selectedList;
AllDataClass.mouseOverPolicy = "";
AllDataClass.userName = "";
AllDataClass.userId = "";

// 언어에 따라 json파일 선택
// 각 json의 텍스트 들은 해당 언어로 되어 있다.
AllDataClass.setLanguage = (lang: string) => {
  if (lang === "ko") {
    AllDataClass.current_json = cms_current_ko;
    AllDataClass.Language = "ko";
  } else {
    AllDataClass.current_json = cms_current_en;
    AllDataClass.Language = "en";
  }
  console.log(lang);
};

AllDataClass.clearAlldata = (lang: string) => {
  AllDataClass.current_json = cms_current_ko;
  AllDataClass.setLanguage(lang);
  AllDataClass.selectedList = new Array();
  AllDataClass.mouseOverPolicy = "";
  AllDataClass.userName = "";
  AllDataClass.userId = "";
  console.log({ AllDataClass });
};

AllDataClass.setUserName = (name: string) => {
  AllDataClass.userName = name;
};
AllDataClass.getUserName = () => {
  return AllDataClass.userName;
};
AllDataClass.setGameId = (id: string) => {
  AllDataClass.userId = id;
};
AllDataClass.getGameId = () => {
  return AllDataClass.userId;
};
// 선택한 정책을 selectedList에 저장한다.
AllDataClass.addSelectedList = (policy: string) => {
  console.log(AllDataClass.selectedList);
  console.log(policy);
  if (policy === "") return;
  if (!AllDataClass.selectedList) AllDataClass.selectedList = new Array();
  if (!AllDataClass.selectedList?.includes(policy)) {
    AllDataClass.selectedList.push(policy);
  }
};
// 선택한 정책을 selectedList에 저장한다.
AllDataClass.removeSelectedList = (policy: string) => {
  AllDataClass.selectedList = AllDataClass.selectedList.filter((item: string) => item !== policy);
};
// 선택된 정책 리스트를 반환한다.
AllDataClass.getSelectedList = () => {
  return AllDataClass.selectedList;
};
// 특정 정책 리스티를 받아 각 년도별 나랏빚 비율을 반환한다.
AllDataClass.getBrookingsDebtRatio = (policies: any[]) => {
  var debtRatio = new Array(AllDataClass.current_json.BudgetRatioCalculationsData.Item.length);
  var debt = new Array(AllDataClass.current_json.BudgetRatioCalculationsData.Item.length);
  var startDebt = AllDataClass.current_json.BudgetRatioCalculationsData.Data.START_DEBT;
  var deficts = AllDataClass.current_json.BudgetRatioCalculationsData.Data.DEFICIT;
  var interests = AllDataClass.current_json.BudgetRatioCalculationsData.Data.INTEREST;
  var PolicyFiscalImpacts: any = AllDataClass.current_json.PolicyFiscalImpacts.Data;
  var GDPS = AllDataClass.current_json.BudgetRatioCalculationsData.Data.GDP;
  for (var i = 0; i < debtRatio.length; i++) {
    if (i == 0) {
      debt[i] = startDebt[i];
    } else {
      var totalDebtImpact = 0;

      policies?.forEach((policy: string) => {
        totalDebtImpact = totalDebtImpact + PolicyFiscalImpacts[policy]?.[i];
      });
      debt[i] = (debt[i - 1] + deficts[i] + totalDebtImpact) / (1 - interests[i]);
    }
    debtRatio[i] = (debt[i] / GDPS[i]) * 100;
  }
  return debtRatio;
};
// 단순히 나랏빚의 GDP비율을 반환한다.
// 기본 정보의 나랏빚 비율을 반환한다.
AllDataClass.getBaseDebtRatio = () => {
  var debtRatio = new Array(AllDataClass.current_json.BudgetRatioCalculationsData.Item.length);
  var startDebt = AllDataClass.current_json.BudgetRatioCalculationsData.Data.START_DEBT;
  var PolicyFiscalImpacts: any = AllDataClass.current_json.PolicyFiscalImpacts.Data;
  var GDPS = AllDataClass.current_json.BudgetRatioCalculationsData.Data.GDP;

  for (var i = 0; i < debtRatio.length; i++) {
    debtRatio[i] = (startDebt[i] / GDPS[i]) * 100;
  }
  return debtRatio;
};
// 정책이 반영된 나랏빚 비율을 반환한다.
AllDataClass.getBaseDebtRatiobyPolicy = (policies: any[]) => {
  if (policies.length < 1) {
    return AllDataClass.getBaseDebtRatio();
  }
  var debtRatio = new Array(AllDataClass.current_json.BudgetRatioCalculationsData.Item.length);
  var startDebt = AllDataClass.current_json.BudgetRatioCalculationsData.Data.START_DEBT;
  var PolicyFiscalImpacts: any = AllDataClass.current_json.PolicyFiscalImpacts.Data;
  var GDPS = AllDataClass.current_json.BudgetRatioCalculationsData.Data.GDP;

  for (var i = 0; i < debtRatio.length; i++) {
    var totalDebtImpact = 0;
    policies?.forEach((policy: string) => {
      totalDebtImpact = totalDebtImpact + PolicyFiscalImpacts[policy]?.[i];
    });

    debtRatio[i] = ((startDebt[i] + totalDebtImpact) / GDPS[i]) * 100;
  }
  return debtRatio;
};

// 소득분배지수, 저소득층 소득분배지수, PYI1의 값을 각 정책별로 계산한여 반환한다.
AllDataClass.getGoalScore = () => {
  var goalScore = [...AllDataClass.current_json.BudgetRatioCalculationsData.Data.BASE_GOAL];
  var policyGoalsImpacts: any = AllDataClass.current_json.PolicyGoalsImpacts.Data;
  AllDataClass.selectedList.forEach((policy: string) => {
    // goalScore[0] =
    //   AllDataClass.current_json.BudgetRatioCalculationsData.Data.BASE_GOAL[0] +
    //   policyGoalsImpacts[policy][0];
    // goalScore[1] =
    //   AllDataClass.current_json.BudgetRatioCalculationsData.Data.BASE_GOAL[1] +
    //   policyGoalsImpacts[policy][1];
    // goalScore[2] =
    //   AllDataClass.current_json.BudgetRatioCalculationsData.Data.BASE_GOAL[2] +
    //   policyGoalsImpacts[policy][2];

    goalScore[0] = goalScore[0] + policyGoalsImpacts[policy][0];
    goalScore[1] = goalScore[1] + policyGoalsImpacts[policy][1];
    goalScore[2] = goalScore[2] + policyGoalsImpacts[policy][2];
  });
  return goalScore;
};
// 목표 달성 목표 값
AllDataClass.getBaseGoalScore = () => {
  return AllDataClass.current_json.BudgetRatioCalculationsData.Data.BASE_GOAL;
};
// json에서 GoverningGoals를 반환한다.
AllDataClass.getGoverningGoals = () => {
  return AllDataClass.current_json.GoverningGoals.Data;
};
// json에서 GoverningGoals중 사용하는 것만 반환한다.
AllDataClass.getEnabledGoverningGoals = () => {
  var GoverningGoals: any = AllDataClass.current_json.GoverningGoals.Data;
  var returnVal = [];
  for (var goal in GoverningGoals) {
    var tempObj: any = {};
    if (GoverningGoals[goal][1] === "Yes") {
      tempObj.goalid = goal;
      tempObj.selected = false;
      tempObj.texts = GoverningGoals[goal];
      returnVal.push(tempObj);
    }
  }
  return returnVal;
};
// json에서 GovGoalConflicts를 반환한다.
AllDataClass.getGovGoalConflicts = () => {
  return AllDataClass.current_json.GovGoalConflicts.Data.Conflicts;
};
// json에서 GovGoalSets을 반환한다.
AllDataClass.getGovGoalSets = () => {
  return AllDataClass.current_json.GovGoalSets.Data.Sets;
};
// json에서 Policies를 반환한다.
AllDataClass.getPolicies = () => {
  return AllDataClass.current_json.Policies.Data;
};
// json에서 PolicyDescriptives를 반환한다.
AllDataClass.getPolicyDescriptives = () => {
  return AllDataClass.current_json.PolicyDescriptives.Data;
};
AllDataClass.getPolicyDescriptivebyID = (policyid: string) => {
  return AllDataClass.current_json.PolicyDescriptives.Data[policyid];
};
// json에서 TunableGameVariables를 반환한다.
AllDataClass.getTunableGameVariables = () => {
  return AllDataClass.current_json.TunableGameVariables.Data;
};
// json에서 PolicyGovGoalImpacts를 반환한다.
AllDataClass.getPolicyGovGoalImpacts = () => {
  return AllDataClass.current_json.PolicyGovGoalImpacts.Data;
};
AllDataClass.getPolicyGovGoalImpactsForGoals = (policies: string[]) => {
  var PolicyGovGoalImpacts = AllDataClass.current_json.PolicyGovGoalImpacts.Data;
  // console.log(PolicyGovGoalImpacts);
  var retVal: any = {};
  policies?.forEach((policy: string) => {
    // console.log(policy);
    // console.log(PolicyGovGoalImpacts[policy]);
    retVal[policy] = [];
    retVal[policy].push(PolicyGovGoalImpacts[policy]);
  });
  return retVal;
};

AllDataClass.getCategoryList = () => {
  var categories: any = {};
  var allCategory = AllDataClass.current_json.Categories.Data;
  for (var cat in allCategory) {
    if (allCategory[cat][3] === "Yes") {
      categories[cat] = [];
      categories[cat] = [...allCategory[cat]];
    }
  }
  return categories;
};

// 카테고리와 해당 카테고리에 포함된 정책과 정책 수를 반환한다.
AllDataClass.getCategoryWithPoliciesCnt = () => {
  var categories: any, PolicyDescriptives: any, Policies: any;
  // categories = AllDataClass.current_json.Categories.Data;
  categories = AllDataClass.getCategoryList();
  // AllDataClass.getCategoryList();
  PolicyDescriptives = AllDataClass.current_json.PolicyDescriptives.Data;
  Policies = AllDataClass.current_json.Policies.Data;
  var categories_cnt = Object.keys(categories).length;
  var cnt1 = Math.ceil(categories_cnt / 6);
  var category = Array.from(Array(cnt1), () => new Array(0));

  var cat_cnt = 0;
  for (var cat in categories) {
    if (categories[cat][3] !== "Yes") continue;
    var policyForCatgory = [];
    categories[cat][4] = 0;
    categories[cat][5] = 0;
    for (var policy in PolicyDescriptives) {
      if (
        Policies[policy][2] === "Yes" &&
        (PolicyDescriptives[policy][0] === categories[cat][0] ||
          PolicyDescriptives[policy][1].includes(categories[cat][2]))
      ) {
        var cnt = categories[cat][4];
        var tempObj: any = {};
        tempObj[policy] = PolicyDescriptives[policy];
        policyForCatgory.push(tempObj);
        cnt++;
        if (AllDataClass?.selectedList?.includes(policy)) {
          categories[cat][5]++;
        }
        categories[cat][4] = cnt;
      }
    }
    categories[cat][6] = policyForCatgory;
    category[Math.floor(cat_cnt / 6)].push(categories[cat]);
    cat_cnt++;
  }
  return category;
};
AllDataClass.getConflictPolicies = (policyid: string) => {
  var conflitList = AllDataClass.current_json.Policies.Data[policyid][0];
  return conflitList;
};
